import { ReactElement, memo, useMemo } from 'react';
import { IActivityWithAvailability } from '@/common/domain/Merge.domain';
import { ImageLabels } from './ImageLabels';
import { ImagesInfinityGallery } from '@/shared/ImagesGallery/ImagesGallery';
import * as S from './ImagesGallery.styles';
import { ImagesGroup } from '@/common/ui/images/ImagesGroup/ImagesGroup';
import { TSlug } from '@/common/domain/Slug.domain';
import { TAssets } from '@/screens/ActivityPage/service/createAssets';

type ImagesGalleryProps = {
    activity: IActivityWithAvailability;
    reviewsCount?: number;
    userImages?: TSlug[];
    disabled?: boolean;
    position: number;
    item_list_id: string;
    item_list_name: string;
    withPaddings?: boolean;
    event: boolean;
};

export const ImagesGalleryContainer = ({
    activity,
    disabled,
    userImages,
    reviewsCount,
    position,
    withPaddings,
    event,
    item_list_name,
    item_list_id,
}: ImagesGalleryProps): ReactElement => {
    const imagesSrc = useMemo<TAssets[]>(() => {
        const userImagesAssets: TAssets[] = userImages
            ? userImages.map(({ id }) => ({ type: 'photo', value: { id, slug: activity.slug } }))
            : [];

        return [
            { type: 'activity', value: { id: activity.id, slug: activity.slug } },
            ...userImagesAssets,
        ];
    }, [activity.id, activity.slug, userImages]);

    const images =
        imagesSrc.length > 1
            ? [imagesSrc[imagesSrc.length - 1], ...imagesSrc, imagesSrc[0]]
            : imagesSrc;

    const imagesElement = () =>
        images.map(({ type, value }, index) => {
            return (
                <S.Container key={index}>
                    <S.ImgWrap>
                        <S.Gradient />
                        <ImagesGroup
                            linkKey={type}
                            id={value.id}
                            slug={value.slug}
                            type="attractions"
                            eager
                        />
                    </S.ImgWrap>
                </S.Container>
            );
        });

    return (
        <ImagesInfinityGallery
            additionalElement={
                <ImageLabels
                    activity={activity}
                    reviewsCount={reviewsCount}
                    disabled={disabled}
                    position={position}
                    item_list_name={item_list_name}
                    item_list_id={item_list_id}
                />
            }
            items={images}
            itemsElement={imagesElement}
            withPaddings={withPaddings}
            event={event}
        />
    );
};

export const PreviewImagesGallery = memo(ImagesGalleryContainer);
